import { AxiosRequestConfig } from 'axios';

// Function to get the API base URL
const getApiBaseUrl = () => {
    const host = window.location.hostname;
    const port = import.meta.env.VITE_API_PORT || '5000';
    
    // If we're using a subdomain, keep the same domain for API
    if (host.includes('dreamzconnect.localhost')) {
        // Use the same subdomain as the frontend
        return `http://${host}:${port}/api/v1`;
    }
    
    // Default to localhost for development
    return `http://localhost:${port}/api/v1`;
};

export const API_CONFIG: AxiosRequestConfig = {
    baseURL: getApiBaseUrl(),
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    validateStatus: (status) => {
        return status >= 200 && status < 300;
    }
};

export const AUTH_CONFIG = {
    tokenKey: 'auth_token',
    tokenType: 'Bearer',
    loginRedirect: '/login',
    defaultRedirect: '/dashboard'
};

export interface APIResponse<T> {
    data: T;
    meta: {
        timestamp: string;
        message?: string;
        total?: number;
    };
}

export interface APIErrorResponse {
    error: {
        message: string;
        details?: string;
    };
} 